// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__fOdp4","label":"Section_label__2t7rD","contentWrap":"Section_contentWrap__2YQO3","footer":"Section_footer__6urPD","footerInner":"Section_footerInner__2Nxk9"};